module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/about-danette-469.81af644e87d80e41.jpg"+" 469w",
        images: [{path: "https://static.sniffspot.com/packs/img/about-danette-469.81af644e87d80e41.jpg",width: 469,height: 327}],
        src: "https://static.sniffspot.com/packs/img/about-danette-469.81af644e87d80e41.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/about-danette-469.81af644e87d80e41.jpg"},
        
        width: 469,
        height: 327
      }